export enum SanctionAppealState {
	NotAppealable = 1,
	Appealed = 2,
	AppealWindowOpen = 3,
	AppealWindowExpired = 4,
}
